import { CSSProperties } from 'react';

import { CFPBox, useCFPValues } from '@bcp-channels-sharedcomponents-reactjs/cf-proxy';
import { ComposableTypography } from '@bcp-nextgen-dx-component-factory/design-system';
import { ArrowRight, Check } from '@bcp-nextgen-dx-component-factory/icons-accolade';
import { UIHelper } from '@helpers';

const MICROCOPY_100_02_APPEARANCE_TOKEN = 'microcopy-100-02';

interface FormHintProps {
	label: string;
	isValid?: boolean;
}

export const FormHint = ({ label, isValid }: FormHintProps) => {
	const { getToken } = useCFPValues();

	const icon = isValid ? (
		<Check.Fill fill="#47C06B" size="xxxSmall" />
	) : (
		<ArrowRight.Outline fill="#8694A7" size="xxxSmall" />
	);

	const styles: CSSProperties = {
		color: isValid ? '' : '#8694A7',
	};

	return (
		<CFPBox styles={{ alignItems: 'center', gap: UIHelper.rem(4) }}>
			{icon}
			<ComposableTypography
				text={label}
				baseProps={{
					appearance: getToken({
						default: {
							default: MICROCOPY_100_02_APPEARANCE_TOKEN,
						},
					}),
					styles,
				}}
				tags={{}}
			/>
		</CFPBox>
	);
};
